// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"NavigationItem_NavigationItem__2SpXc","active":"NavigationItem_active__2v2td"};